import { fork } from 'redux-saga/effects';

import { watcher as paperworkVerifyDobWatcher } from '../requests/paperwork-verify-dob';
import { watcher as paperworkGetAppointmentDetailsWatcher } from '../requests/paperwork-get-appointment-details';
import { watcher as paperworkGetUserDetailsWatcher } from '../requests/paperwork-get-user-details';
import { watcher as paperworkSubmitAppointmentWatcher } from '../requests/paperwork-submit-appointment';
import { watcher as paperworkAppointmentSessionWatcher } from '../requests/paperwork-appointment-session';
import { watcher as paperworkAdditionalInfoWatcher } from '../requests/paperwork-get-additional-info';
import { selectPaperworkFlowVerifiedUserDataSaga } from './set-paperwork-flow-verified-user-data';
import { validateInitialPaperworkPage } from './validate-initial-paperwork-page';
import { determinePaperworkFlowRoutes } from './determine-paperwork-flow-routes';

export default function* paperworkRootSaga() {
  yield fork(paperworkVerifyDobWatcher);
  yield fork(paperworkGetAppointmentDetailsWatcher);
  yield fork(paperworkGetUserDetailsWatcher);
  yield fork(paperworkSubmitAppointmentWatcher);
  yield fork(paperworkAppointmentSessionWatcher);
  yield fork(paperworkAdditionalInfoWatcher);

  yield fork(selectPaperworkFlowVerifiedUserDataSaga);
  yield fork(validateInitialPaperworkPage);
  yield fork(determinePaperworkFlowRoutes);
}



// WEBPACK FOOTER //
// ./src/redux/paperwork/sagas/index.js